import ReactDOM from "react-dom";
import { BrowserRouter,Route,Routes } from "react-router-dom";
import Home from "./app/pages/home";
import Portfolio from "./app/pages/portfolio";
import Contact from "./app/pages/contact"
import About from "./app/pages/about";
import Drop from "./app/components/drop";
import Skills from "./app/pages/skills";
import { CurrentTheme } from "./app/components/currentTheme";

const rootElement = document.getElementById("root");
ReactDOM.render(
  <>
  <CurrentTheme>
    <BrowserRouter>
     <Routes>
        <Route path="/" element={<Home/>}></Route>
        <Route path="/services" element={<Skills/>}></Route>
        <Route path="/demos" element={<Portfolio/>}></Route>
        <Route path="/contact" element={<Contact/>}></Route>
        <Route path="/about" element={<About/>}></Route>
        <Route path="/drop" element={<Drop/>}></Route>
      </Routes>
    </BrowserRouter>
    </CurrentTheme>
  </>,
  rootElement
);
